import {
  createErrorType,
  createSubmitType,
  createSuccessType,
  createLoadingType,
  createUpdateType,
  createDeleteType,
} from '../actionHelpers';

const APPLICATION_FUNDING_SCOPE = 'APPLICATION_FUNDING';
export const APPLICATION_FUNDING = createSubmitType(APPLICATION_FUNDING_SCOPE);
export const APPLICATION_FUNDING_SUCCESS = createSuccessType(
  APPLICATION_FUNDING_SCOPE,
);
export const APPLICATION_FUNDING_ERROR = createErrorType(
  APPLICATION_FUNDING_SCOPE,
);
export const APPLICATION_FUNDING_LOADING = createLoadingType(
  APPLICATION_FUNDING_SCOPE,
);

const UPDATE_APPLICATION_FUNDING_SCOPE = 'UPDATE_APPLICATION_FUNDING';
export const UPDATE_APPLICATION_FUNDING = createUpdateType(
  UPDATE_APPLICATION_FUNDING_SCOPE,
);
export const UPDATE_APPLICATION_FUNDING_SUCCESS = createSuccessType(
  UPDATE_APPLICATION_FUNDING_SCOPE,
);
export const UPDATE_APPLICATION_FUNDING_ERROR = createErrorType(
  UPDATE_APPLICATION_FUNDING_SCOPE,
);
export const UPDATE_APPLICATION_FUNDING_LOADING = createLoadingType(
  UPDATE_APPLICATION_FUNDING_SCOPE,
);

const DELETE_APPLICATION_FUNDING_SCOPE = 'DELETE_APPLICATION_FUNDING';
export const DELETE_APPLICATION_FUNDING = createDeleteType(
  DELETE_APPLICATION_FUNDING_SCOPE,
);
export const DELETE_APPLICATION_FUNDING_SUCCESS = createSuccessType(
  DELETE_APPLICATION_FUNDING_SCOPE,
);
export const DELETE_APPLICATION_FUNDING_ERROR = createErrorType(
  DELETE_APPLICATION_FUNDING_SCOPE,
);
export const DELETE_APPLICATION_FUNDING_LOADING = createLoadingType(
  DELETE_APPLICATION_FUNDING_SCOPE,
);

const BANK_APPLICATION_FUNDING_SCOPE = 'BANK_APPLICATION_FUNDING';
export const BANK_APPLICATION_FUNDING = createSubmitType(
  BANK_APPLICATION_FUNDING_SCOPE,
);
export const BANK_APPLICATION_FUNDING_SUCCESS = createSuccessType(
  BANK_APPLICATION_FUNDING_SCOPE,
);
export const BANK_APPLICATION_FUNDING_ERROR = createErrorType(
  BANK_APPLICATION_FUNDING_SCOPE,
);
export const BANK_APPLICATION_FUNDING_LOADING = createLoadingType(
  BANK_APPLICATION_FUNDING_SCOPE,
);

const UPDATE_BANK_APPLICATION_FUNDING_SCOPE = 'UPDATE_BANK_APPLICATION_FUNDING';
export const UPDATE_BANK_APPLICATION_FUNDING = createUpdateType(
  UPDATE_BANK_APPLICATION_FUNDING_SCOPE,
);
export const UPDATE_BANK_APPLICATION_FUNDING_SUCCESS = createSuccessType(
  UPDATE_BANK_APPLICATION_FUNDING_SCOPE,
);
export const UPDATE_BANK_APPLICATION_FUNDING_ERROR = createErrorType(
  UPDATE_BANK_APPLICATION_FUNDING_SCOPE,
);
export const UPDATE_BANK_APPLICATION_FUNDING_LOADING = createLoadingType(
  UPDATE_BANK_APPLICATION_FUNDING_SCOPE,
);

const APPLICATION_FUNDING_AMOUNT_SCOPE = 'APPLICATION_FUNDING_AMOUNT';
export const APPLICATION_FUNDING_AMOUNT = createSubmitType(
  APPLICATION_FUNDING_AMOUNT_SCOPE,
);
export const APPLICATION_FUNDING_AMOUNT_SUCCESS = createSuccessType(
  APPLICATION_FUNDING_AMOUNT_SCOPE,
);
export const APPLICATION_FUNDING_AMOUNT_ERROR = createErrorType(
  APPLICATION_FUNDING_AMOUNT_SCOPE,
);
export const APPLICATION_FUNDING_AMOUNT_LOADING = createLoadingType(
  APPLICATION_FUNDING_AMOUNT_SCOPE,
);

const UPDATE_APPLICATION_FUNDING_AMOUNT_SCOPE =
  'UPDATE_APPLICATION_FUNDING_AMOUNT';
export const UPDATE_APPLICATION_FUNDING_AMOUNT = createUpdateType(
  UPDATE_APPLICATION_FUNDING_AMOUNT_SCOPE,
);
export const UPDATE_APPLICATION_FUNDING_AMOUNT_SUCCESS = createSuccessType(
  UPDATE_APPLICATION_FUNDING_AMOUNT_SCOPE,
);
export const UPDATE_APPLICATION_FUNDING_AMOUNT_ERROR = createErrorType(
  UPDATE_APPLICATION_FUNDING_AMOUNT_SCOPE,
);
export const UPDATE_APPLICATION_FUNDING_AMOUNT_LOADING = createLoadingType(
  UPDATE_APPLICATION_FUNDING_AMOUNT_SCOPE,
);

const BANK_APPLICATION_FUNDING_AMOUNT_SCOPE = 'BANK_APPLICATION_FUNDING_AMOUNT';
export const BANK_APPLICATION_FUNDING_AMOUNT = createSubmitType(
  BANK_APPLICATION_FUNDING_AMOUNT_SCOPE,
);
export const BANK_APPLICATION_FUNDING_AMOUNT_SUCCESS = createSuccessType(
  BANK_APPLICATION_FUNDING_AMOUNT_SCOPE,
);
export const BANK_APPLICATION_FUNDING_AMOUNT_ERROR = createErrorType(
  BANK_APPLICATION_FUNDING_AMOUNT_SCOPE,
);
export const BANK_APPLICATION_FUNDING_AMOUNT_LOADING = createLoadingType(
  BANK_APPLICATION_FUNDING_AMOUNT_SCOPE,
);

const UPDATE_BANK_APPLICATION_FUNDING_AMOUNT_SCOPE =
  'UPDATE_BANK_APPLICATION_FUNDING_AMOUNT';
export const UPDATE_BANK_APPLICATION_FUNDING_AMOUNT = createUpdateType(
  UPDATE_BANK_APPLICATION_FUNDING_AMOUNT_SCOPE,
);
export const UPDATE_BANK_APPLICATION_FUNDING_AMOUNT_SUCCESS = createSuccessType(
  UPDATE_BANK_APPLICATION_FUNDING_AMOUNT_SCOPE,
);
export const UPDATE_BANK_APPLICATION_FUNDING_AMOUNT_ERROR = createErrorType(
  UPDATE_BANK_APPLICATION_FUNDING_AMOUNT_SCOPE,
);
export const UPDATE_BANK_APPLICATION_FUNDING_AMOUNT_LOADING = createLoadingType(
  UPDATE_BANK_APPLICATION_FUNDING_AMOUNT_SCOPE,
);

// add metalStream funding

const METAL_STREAM_FUNDING_SCOPE = 'METAL_STREAM_FUNDING';
export const METAL_STREAM_FUNDING = createSubmitType(
  METAL_STREAM_FUNDING_SCOPE,
);
export const METAL_STREAM_FUNDING_SUCCESS = createSuccessType(
  METAL_STREAM_FUNDING_SCOPE,
);
export const METAL_STREAM_FUNDING_ERROR = createErrorType(
  METAL_STREAM_FUNDING_SCOPE,
);
export const METAL_STREAM_FUNDING_LOADING = createLoadingType(
  METAL_STREAM_FUNDING_SCOPE,
);

// update metalStream funding

const UPDATE_METAL_STREAM_FUNDING_SCOPE = 'UPDATE_METAL_STREAM_FUNDING';
export const UPDATE_METAL_STREAM_FUNDING = createSubmitType(
  UPDATE_METAL_STREAM_FUNDING_SCOPE,
);
export const UPDATE_METAL_STREAM_FUNDING_SUCCESS = createSuccessType(
  UPDATE_METAL_STREAM_FUNDING_SCOPE,
);
export const UPDATE_METAL_STREAM_FUNDING_ERROR = createErrorType(
  UPDATE_METAL_STREAM_FUNDING_SCOPE,
);
export const UPDATE_METAL_STREAM_FUNDING_LOADING = createLoadingType(
  UPDATE_METAL_STREAM_FUNDING_SCOPE,
);
